import { render, staticRenderFns } from "./regx-add.vue?vue&type=template&id=b9114114&scoped=true&"
import script from "./regx-add.vue?vue&type=script&lang=js&"
export * from "./regx-add.vue?vue&type=script&lang=js&"
import style0 from "./regx-add.vue?vue&type=style&index=0&id=b9114114&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9114114",
  null
  
)

export default component.exports